export const ADD_MULTISTEP = "multiStepReducer/add_multistep";
export const REMOVE_MULTISTEP = "multiStepReducer/remove_multistep";
export const SET_STEP = "multiStepReducer/set_step";
export const RESET = "multiStepReducer/reset";
